import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useState, useRef } from 'react';
import { DayPickerSingleDateController } from 'react-dates';
import moment from 'moment';
import { DatePickerHeader, DatePickerNavigation, DatePickerDay } from '@elliemae/ds-date-picker';
import ChevronLeft from '@elliemae/ds-icons/ChevronLeft';
import { aggregatedClasses, convertPropToCssClassName } from '@elliemae/ds-classnames';

var blockname = 'single-date';
var Wrapper = aggregatedClasses('div')(blockname, 'wrapper');

var _convertPropToCssClas = convertPropToCssClassName('datepicker'),
    classNameElement = _convertPropToCssClas.classNameElement,
    classNameBlock = _convertPropToCssClas.classNameBlock;

var DatePickerSingleDate = function DatePickerSingleDate(_ref) {
  var date = _ref.date,
      _ref$displayFormatDay = _ref.displayFormatDay,
      displayFormatDay = _ref$displayFormatDay === void 0 ? 'D' : _ref$displayFormatDay,
      _ref$isDayHighlighted = _ref.isDayHighlighted,
      isDayHighlighted = _ref$isDayHighlighted === void 0 ? function () {
    return false;
  } : _ref$isDayHighlighted,
      _ref$enableOutsideDay = _ref.enableOutsideDays,
      enableOutsideDays = _ref$enableOutsideDay === void 0 ? true : _ref$enableOutsideDay,
      _ref$showHeader = _ref.showHeader,
      showHeader = _ref$showHeader === void 0 ? true : _ref$showHeader,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      rest = _objectWithoutProperties(_ref, ["date", "displayFormatDay", "isDayHighlighted", "enableOutsideDays", "showHeader", "onChange"]);

  var _useState = useState(date),
      _useState2 = _slicedToArray(_useState, 2),
      selectedDate = _useState2[0],
      setSelectedDate = _useState2[1];

  var _useState3 = useState(moment()),
      _useState4 = _slicedToArray(_useState3, 2),
      key = _useState4[0],
      setKey = _useState4[1];

  var datePickerRef = useRef();

  var updateKeyDate = function updateKeyDate(newDate) {
    setKey(newDate);
  };

  var handleDateChange = function handleDateChange(newDate) {
    setSelectedDate(newDate);
    setTimeout(function () {
      return onChange(newDate);
    }, 500);
  };

  return /*#__PURE__*/React.createElement(Wrapper, null, showHeader && /*#__PURE__*/React.createElement(DatePickerHeader, {
    onInputChange: handleDateChange,
    selectedDate: selectedDate,
    updateKeyDate: updateKeyDate
  }), /*#__PURE__*/React.createElement("div", {
    ref: datePickerRef,
    className: classNameBlock('wrapper-day-picker-single-date-controller'),
    "data-testid": rest['data-testid'] || 'date-picker-single-date'
  }, /*#__PURE__*/React.createElement(DayPickerSingleDateController, {
    key: key,
    date: selectedDate,
    enableOutsideDays: enableOutsideDays,
    focused: true,
    hideKeyboardShortcutsPanel: true,
    isDayHighlighted: isDayHighlighted,
    keepOpenOnDateSelect: true,
    navNext: /*#__PURE__*/React.createElement(DatePickerNavigation, {
      className: classNameElement('navigation-next')
    }),
    navPrev: /*#__PURE__*/React.createElement(DatePickerNavigation, {
      className: classNameElement('navigation-prev'),
      icon: ChevronLeft
    }),
    onDateChange: handleDateChange,
    renderDayContents: function renderDayContents(givenDate) {
      return /*#__PURE__*/React.createElement(DatePickerDay, {
        className: classNameElement('day-contents'),
        date: givenDate.format(displayFormatDay)
      });
    }
  })));
};

export default DatePickerSingleDate;
//# sourceMappingURL=DatePickerSingleDate.js.map
